export default __webpack_public_path__ + "static/media/sofa-hd.95f15365.png";